import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    inProgress: {
      description: () => 'Created on {createdAt}',
    },
    withFiscalId: {
      description: () => '{fiscalId} · Emitted on {createdAt}',
    },
  },
  fr: {
    inProgress: {
      description: (isInvoice?: boolean) =>
        `${isInvoice ? 'Créée' : 'Crée'} le {createdAt}`,
    },
    withFiscalId: {
      description: (isInvoice?: boolean) =>
        `{fiscalId} · ${isInvoice ? 'Émise' : 'Émis'} le {createdAt}`,
    },
  },
} as const);

export default locales;
